var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProductStarRating(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.55278 0.798626C9.85938 -0.10725 11.1406 -0.107252 11.4472 0.798624L13.0765 5.61239C13.2139 6.01849 13.595 6.2918 14.0237 6.2918H19.2065C20.185 6.2918 20.5812 7.55218 19.7785 8.112L15.6568 10.9869C15.2919 11.2413 15.139 11.7063 15.2816 12.1276L16.8724 16.8277C17.1818 17.7419 16.1447 18.5207 15.3531 17.9685L11.0721 14.9826C10.7284 14.7429 10.2716 14.7429 9.92793 14.9826L5.64689 17.9685C4.8553 18.5207 3.81819 17.7419 4.1276 16.8277L5.71838 12.1276C5.861 11.7063 5.70812 11.2413 5.34324 10.9869L1.22147 8.112C0.418839 7.55218 0.814969 6.2918 1.79355 6.2918H6.97631C7.40505 6.2918 7.78608 6.01849 7.92353 5.61239L9.55278 0.798626Z",
    fill: "#F1CD11"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductStarRating);
export default __webpack_public_path__ + "static/media/product_star_rating.95e01d3369c53170cdd3fefd0c885279.svg";
export { ForwardRef as ReactComponent };